{
  "title": "Tablo bord xaalis",
  "revenue_today": "Xaalis bi tey",
  "revenue_mtd": "Xaalis bi ci weer wi",
  "orders_today": "Komand yi tey",
  "avg_order_value": "Njëg mooytu komand",
  "vs_previous": "ak période bi weesu",
  "revenue_chart": "Yoonu xaalis bi",
  "last_7_days": "7 fan yi weesu",
  "last_30_days": "30 fan yi weesu",
  "payment_breakdown": "Faral ci yoonu fey yi",
  "wave": "Wave",
  "orange_money": "Orange Money",
  "cod": "Fey ci jëlëg",
  "brand_revenue": "Xaalis ci marka",
  "brand": "Marka",
  "revenue": "Xaalis",
  "orders": "Komand yi",
  "avg_value": "Njëg mooytu",
  "top_product": "Produwe bu gën a jënd",
  "tva_panel": "Tënk TVA",
  "gross_revenue": "CA brut",
  "tva_rate": "Taux TVA",
  "tva_collected": "TVA bu ñu jële",
  "net_revenue": "CA net (TVA amul ci biir)",
  "period": "Période",
  "sage_export": "Export Sage",
  "sage_export_desc": "Sos ab fichier bu baax ak Sage",
  "download_csv": "Wàcce CSV",
  "period_daily": "Bés bu nekk",
  "period_weekly": "Ayu-bis",
  "period_monthly": "Weer",
  "period_quarterly": "Ñetti weer",
  "countre_dairy": "Countre Dairy",
  "yousra": "Yousra",
  "florida": "Florida",
  "kamax": "KamaX",
  "zone": "Zone",
  "no_data": "Amul données",
  "loading": "Yéegal ci kanam...",
  "export_generated": "Export bi jeex na ak jàmm",
  "fcfa": "FCFA"
}
